export default __webpack_public_path__ + "static/media/i-circule-medium.caa45757.svg";